import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from '../../AppContext';

const OrdersReset = ({
    selectedOrder,
    onClose,
    onSuccess
}) => {
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');

    useEffect(() => {
        setnutxuly(0);
        setnutorder('✔️ Click to Confirm');
    }, [selectedOrder]);

    if (!selectedOrder) {
        return null;
    }

    const handleConfirmReorder = async () => {
        if (nutxuly == 1) {
            return;
        }

        const apikey = Cookies.get('apikey');
        if (!apikey) {
            alert_error('Không tìm thấy apikey, vui lòng đăng nhập lại');
            return;
        }

        const serviceId = selectedOrder?.service_id || selectedOrder?.service || '';
        if (!serviceId) {
            alert_error('Không tìm thấy service_id để thuê lại');
            return;
        }

        setnutxuly(1);
        setnutorder('Please wait a moment 😊');

        try {
            const response = await axios.post('https://nginx.hust.media/go/otp/process/orders', {
                quantity: 1,
                apikey: apikey,
                service: serviceId,
                captcha: '',
                chedo: 'reset',
                social: 'AUTO',
                url: selectedOrder?.url
            });

            const info = response?.data || {};
            setnutxuly(0);

            if (info.status == 0) {
                setnutorder('đặt tiếp luôn nào');
                alert_error(info.message || 'Đặt lại thất bại');
            }
            else if (info.status == 1) {
                setnutorder('Thành công');
                alert_success(info.message || 'Đặt lại thành công');
                if (onClose) {
                    onClose();
                }
                const historyResponse = await axios.get('https://nginx.hust.media/go/otp/process/history?apikey=' + apikey).catch(() => null);
                if (onSuccess) {
                    onSuccess(info, historyResponse?.data);
                }
            }
            else {
                setnutorder('đã xảy ra lỗi vui lòng liên hệ admin');
            }

            if (info.redirect != null && info.redirect != '') {
                setTimeout(function () {
                    window.location.href = info.redirect;
                }, 1700);
            }
        } catch (error) {
            setnutxuly(0);
            setnutorder('✔️ Click to Confirm');
            alert_error(error?.response?.data?.message || error?.message || 'Có lỗi xảy ra khi thuê lại');
        }
    };

    return (
        <div className='mx-2 mt-2 mb-3 rounded-md border border-pink-300 bg-white p-2'>
            <div className='flex items-center justify-between text-sm lg:text-base mb-1'>
                <div className='font-medium'>Thuê lại số</div>
                <button
                    type='button'
                    onClick={onClose}
                    className='ml-2 text-xl font-bold leading-none text-gray-500 hover:text-red-500'
                >
                    x
                </button>
            </div>
            <div className='text-xs lg:text-base mb-2'>
                Số thuê lại: <span className='font-semibold'>{selectedOrder.url}</span>
                <div className='text-[11px] lg:text-sm text-gray-600'>
                    Dịch vụ: <span className='font-semibold'>{selectedOrder.service_name || selectedOrder.service_id || 'N/A'}</span>
                </div>
            </div>

            <button
                type='button'
                disabled={nutxuly == 1}
                onClick={handleConfirmReorder}
                className='mt-2 mb-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 w-full dark:bg-slate-800 dark:text-white'
            >
                <div className='flex items-center justify-between flex-1'>
                    {nutxuly == 1 &&
                        <div className="spinner-border" role="status">
                        </div>}

                    <span className='text-lg font-medium text-white'>
                        {nutorder}
                    </span>
                    <div className="text-xl">
                        {'\u27A4'}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default OrdersReset;
